import { render, staticRenderFns } from "./shop-product-carts.vue?vue&type=template&id=0c2674f8&"
import script from "./shop-product-carts.vue?vue&type=script&lang=js&"
export * from "./shop-product-carts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports